import Vue from "vue"
import i18n from "@/i18n"

Vue.filter( "i18n", label => i18n.t( label ) )